import { MatDialog } from "@angular/material/dialog";
import { Injectable } from "@angular/core";
import { ErrorDialogComponent } from "app/shared/dialogs/error-dialog/error-dialog.component";
import { catchError, lastValueFrom, Observable, switchMap, take, tap } from "rxjs";
import { ApiService } from "app/shared/apis/api.service";
import { IFilterPagination } from "app/shared/interfaces/filter-interface";
import { IPagination } from "app/shared/interfaces/pagination.dto";
import { AuthService } from "app/core/auth/auth.service";
import { CEP } from "../interfaces/cep.interface";

@Injectable({
    providedIn: "root",
})
export class CepService {
    constructor(private api: ApiService, private authService: AuthService, private _matDialog: MatDialog) {}
    endpoind = "api/cep";

    buscar(cep: string) {
        return this.api.getSub<CEP>(this.endpoind + "/"+cep);
    }

    openDialogErro(item: { title: String; message: String }): void {
        const { ...data } = item;
        const dialogRef = this._matDialog.open(ErrorDialogComponent, {
            panelClass: "notification-dialog",
            width: "500px",
            data: item,
        });
    }
}
